import React, { Component } from "react";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";

import InputForm from "../../components/InputForm/InputForm";

import { switchAdminProductsFilters } from '../../actions/adminProductsActions';

import CloseIcon from "../../assets/img/icons/close.png";
import FilterIcon from "../../assets/img/icons/filter.png";
import PropTypes from "prop-types";
import {connect} from "react-redux";

/**
 * ModalFilters Component ( render a modal with Filters Form and returns information to filter assignments )
 *
 * @export Class Component
 * @class ModalFilters
 * @extends {Component}
 * @returns class
 */
class ModalFilters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assignments: [],
            certificate: '',
            subscriber: '',
            delivery: '',
            deliveryTime: '',
            status: '',
            document: '',
            serial: '',
            email: '',
            errors: {}
        };
    }

    onChangeInput = e => {
        this.setState({ [e.target.id]: e.target.value, errors: {} });
    };

    toggleAlertModal = async () => {
        this.setState({ modalAlert: !this.state.modalAlert });
    };

    onFilter = e => {
        e.preventDefault();

        const { certificate, subscriber, delivery, deliveryTime, status, document, serial, email } = this.state;

        let isEmptyForm = (certificate === '' && subscriber === '' && delivery === '' && deliveryTime === '' && status === '' && document === '' && serial === '' && email === '');

        if (!isEmptyForm) {
            this.setState(
                { assignments: this.props.assignments },
                async () => {
                    let allItems = this.state.assignments;
                    let filteredAssignments;

                    if (certificate !== '') {
                        filteredAssignments = await allItems.filter(i => {
                            return i.productName.toLowerCase().indexOf(certificate.toLowerCase()) > -1;
                        });
                        allItems = filteredAssignments;
                    }
                    if (subscriber !== '') {
                        filteredAssignments = await allItems.filter(i => {
                            return i.subscriber.toLowerCase().indexOf(subscriber.toLowerCase()) > -1;
                        });
                        allItems = filteredAssignments;
                    }
                    if (delivery !== '') {
                        filteredAssignments = await allItems.filter(i => {
                            return i.delivery.toLowerCase().indexOf(delivery.toLowerCase()) > -1;
                        });
                        allItems = filteredAssignments;
                    }
                    if (deliveryTime !== '') {
                        filteredAssignments = await allItems.filter(i => {
                            return i.deliveryTime.toLowerCase().indexOf(deliveryTime.toLowerCase()) > -1;
                        });
                        allItems = filteredAssignments;
                    }
                    if (status !== '') {
                        filteredAssignments = await allItems.filter(i => {
                            return i.statusProcess.toLowerCase().indexOf(status.toLowerCase()) > -1;
                        });
                        allItems = filteredAssignments;
                    }
                    if (document !== '') {
                        filteredAssignments = await allItems.filter(i => {
                            return i.document.toLowerCase().indexOf(document.toLowerCase()) > -1;
                        });
                        allItems = filteredAssignments;
                    }
                    if (serial !== '') {
                        filteredAssignments = await allItems.filter(i => {
                            return i.serial.toString().toLowerCase().indexOf(serial.toLowerCase()) > -1;
                        });
                        allItems = filteredAssignments;
                    }
                    if (email !== '') {
                        filteredAssignments = await allItems.filter(i => {
                            return i.subscriberEmail.toLowerCase().indexOf(email.toLowerCase()) > -1;
                        });
                        allItems = filteredAssignments;
                    }

                    this.props.onFilter({assignments: filteredAssignments});
                }
            );
        } else {
            this.props.refreshTable();
        }

        this.props.switchAdminProductsFilters(isEmptyForm);
        this.props.toggleModal('modalFilters');
    };

    render() {
        return (
            <Modal isOpen = {this.props.showModal}>
                <form onSubmit = {e => this.onFilter(e)}>
                    <ModalHeader className = "header-modal">
                        FILTROS AVANZADOS
                        <Button className = "modal-close" onClick = {e => {
                            this.props.toggleModal('modalFilters');
                            this.setState({
                                certificate: '', subscriber: '', delivery: '', deliveryTime: '',
                                status: '', document: '', serial: '', email: ''
                            });
                        }}><img src = {CloseIcon} alt = "icon product"/></Button>
                    </ModalHeader>

                    <ModalBody>
                        <div className = "container">
                            <div className = "row text-center">

                                <div className = "col-md-6 text-left">
                                    <div className = "form-group">
                                        <InputForm
                                            id="certificate"
                                            type={"text"}
                                            placeholder={"Certificado"}
                                            className="form-control text-input"
                                            onChange={e => this.onChangeInput(e)}
                                            value={this.state.certificate}
                                        />
                                    </div>
                                    <div className = "form-group">
                                        <InputForm
                                            id="subscriber"
                                            type={"text"}
                                            placeholder={"Suscriptor"}
                                            className="form-control text-input"
                                            onChange={e => this.onChangeInput(e)}
                                            value={this.state.subscriber}
                                        />
                                    </div>
                                    <div className = "form-group">
                                        <InputForm
                                            id="delivery"
                                            type={"text"}
                                            placeholder={"Entrega"}
                                            className="form-control text-input"
                                            onChange={e => this.onChangeInput(e)}
                                            value={this.state.delivery}
                                        />
                                    </div>
                                    <div className = "form-group">
                                        <InputForm
                                            id="deliveryTime"
                                            type={"text"}
                                            placeholder={"Tiempo Entrega"}
                                            className="form-control text-input"
                                            onChange={e => this.onChangeInput(e)}
                                            value={this.state.deliveryTime}
                                        />
                                    </div>
                                </div>

                                <div className = "col-md-6 text-left">
                                    <div className = "form-group">
                                        <InputForm
                                            id="status"
                                            type={"text"}
                                            placeholder={"Estado"}
                                            className="form-control text-input"
                                            onChange={e => this.onChangeInput(e)}
                                            value={this.state.status}
                                        />
                                    </div>
                                    <div className = "form-group">
                                        <InputForm
                                            id="document"
                                            type={"text"}
                                            placeholder={"Documento"}
                                            className="form-control text-input"
                                            onChange={e => this.onChangeInput(e)}
                                            value={this.state.document}
                                        />
                                    </div>
                                    <div className = "form-group">
                                        <InputForm
                                            id="serial"
                                            type={"text"}
                                            placeholder={"Serial"}
                                            className="form-control text-input"
                                            onChange={e => this.onChangeInput(e)}
                                            value={this.state.serial}
                                        />
                                    </div>
                                    <div className = "form-group">
                                        <InputForm
                                            id="email"
                                            type={"email"}
                                            placeholder={"Correo Electrónico"}
                                            className="form-control text-input"
                                            onChange={e => this.onChangeInput(e)}
                                            value={this.state.email}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </ModalBody>

                    <ModalFooter className = "text-center">
                        <div className = "col-12">
                            <button type = "submit" className = "btn btn-outline-success btn-submit-product">
                                <img className = "input-icon" src = {FilterIcon} alt = "Buscar"/>
                                Buscar
                            </button>
                        </div>
                    </ModalFooter>
                </form>
            </Modal>
        );
    };
}

ModalFilters.propTypes = {
    switchAdminProductsFilters: PropTypes.func.isRequired,
    adminProductsReducer: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    adminProductsReducer: state.adminProductsReducer
});

export default connect(mapStateToProps, { switchAdminProductsFilters })(ModalFilters)